import Modal from 'components/common/modal/index';
import * as React from 'react';

const { useRef, useState, useEffect } = React;

import './index.scss';

export interface IPopupProps {
    children?: any;
    show: boolean;
    onModalClick?: () => void;
    styleSet?: string;
    modalClassSet?: string;
    modalStyleSet?: React.CSSProperties;
}

const animationCssName = 'popup--slide-in';

export default function Popup(props: IPopupProps) {
    const ref = useRef<HTMLDivElement>(null);
    const [showModal, setModal] = useState(false);
    useEffect(() => {
        const el = ref.current;
        let timerId: number;
        if (el) {
            if (props.show) {
                setModal(props.show);
                setTimeout(() => {
                    el.classList.add(animationCssName);
                }, 0);
            } else {
                el.classList.remove(animationCssName);
                setModal(props.show);
            }
        }

        // clean up effect
        return () => clearTimeout(timerId);
    }, [props.show]);
    return (
        <>
            <Modal
                styleSet={props.modalStyleSet}
                show={showModal}
                clickModal={() => {
                    props.onModalClick && props.onModalClick();
                }}
                className={props.modalClassSet}
            />
            <div ref={ref} className={`${props.styleSet || ''} popup`}>
                {props.children}
            </div>
        </>
    );
}
